import { TENANT } from '../../../tenant'

const expasToShowFirstImpressionWidgetPerTenant: Partial<
  Record<TENANT, Set<string>>
> = {
  [TENANT.AT]: new Set([
    'ads',
    'bea',
    'bil',
    'con',
    'def1',
    'def2',
    'def3',
    'dom',
    'doo',
    'gglp',
    'gue',
    'ide',
    'lad',
    'led',
    'leg',
    'sho',
    'shof',
    'shp',
    'tlp',
    'twe',
  ]),
  [TENANT.BE]: new Set([
    'ads',
    'adstr',
    'besl',
    'bil',
    'del',
    'gglp',
    'gue',
    'kie',
    'ovtp',
    'sho',
    'shof',
    'verg',
  ]),
  [TENANT.CH]: new Set([
    'ads',
    'bil',
    'com',
    'de1',
    'de2',
    'de3',
    'doo',
    'gglp',
    'gue',
    'kel',
    'ovtp',
    'pre',
    'shof',
    'shop',
  ]),
  [TENANT.COM]: new Set([
    'ads',
    'bil',
    'con',
    'def1',
    'def2',
    'def3',
    'doo',
    'eba',
    'gei',
    'gglp',
    'gue',
    'kel',
    'mev',
    'ovtp',
    'pre',
    's24',
    'sho',
    'shof',
    'shom',
    'shp',
    'sty',
    'tes',
    'twe',
  ]),
  [TENANT.FR]: new Set([
    'ads',
    'bea',
    'bil',
    'con',
    'def1',
    'def2',
    'def3',
    'dom',
    'doo',
    'gglp',
    'gue',
    'ide',
    'lad',
    'led',
    'leg',
    'sho',
    'shof',
    'shp',
    'tlp',
    'twe',
  ]),
  [TENANT.IT]: new Set([
    'ads',
    'bil',
    'con',
    'gglp',
    'gue',
    'ide',
    'kel',
    'lad',
    'prez',
    'sho',
    'shof',
  ]),
}

export const productPageExpaShouldShowFirstImpressionWidget = ({
  expa,
  tenant,
}: {
  expa: string | null
  tenant: TENANT
}): boolean => {
  if (!expa) {
    return false
  }

  return expasToShowFirstImpressionWidgetPerTenant[tenant]?.has(expa) ?? false
}
